import { render, staticRenderFns } from "./RiskFactorTable.vue?vue&type=template&id=6f69b16c&"
import script from "./RiskFactorTable.vue?vue&type=script&lang=js&"
export * from "./RiskFactorTable.vue?vue&type=script&lang=js&"
import style0 from "./RiskFactorTable.vue?vue&type=style&index=0&id=6f69b16c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports